import { latLonToEN } from '../ol-utils';
import { FeatureMouseInteraction } from '../interaction/FeatureMouseInteraction';
import Feature, { FeatureLike } from 'ol/Feature';
import { Point as OlPoint } from 'ol/geom';
import * as olStyle from 'ol/style';

let lastIndex = 1;
const FEATURE_TYPE = 'tek_point';
const styleCache = {};

function styleFunction(feature: FeatureLike, labelProps: string[]) {
    if (!labelProps.length) {
        return null;
    }

    const point = feature.get('data');
    let color = '0,0,0';
    const labels = [];

    const label = labels.join('\n');

    if (point.props?.color) {
        color = point.props.color;
    }

    const cacheKey = color + '_' + label;
    if (styleCache[cacheKey]) {
        return styleCache[cacheKey];
    }

    styleCache[cacheKey] = [
        new olStyle.Style({
            text: label.length
                ? new olStyle.Text({
                      text: label,
                      overflow: true,
                      font: '14px monospace',
                      offsetY: 2,
                      offsetX: 10,
                      textAlign: 'left',
                  })
                : null,
        }),
    ];

    return styleCache[cacheKey];
}

function makeFeature(point: IOutlinePoint, mouseInteraction?: FeatureMouseInteraction): Feature {
    const coord: Coordinate = latLonToEN(point.lat, point.lon);
    if (!coord) {
        console.warn('Skipping bad outline point: ', point);
        throw new Error();
    }

    const feature = new Feature({
        geometry: new OlPoint(coord),
    });

    const source: FeatureSource = {};
    if (point.sourceModelId) source.modelId = point.sourceModelId;
    if (point.filename) source.modelName = point.filename;

    feature.set('index', lastIndex++, true);
    feature.set('source', source, true);
    feature.set('data', point, true);
    feature.set('type', FEATURE_TYPE, true);
    feature.set('mouseInteraction', mouseInteraction, true);

    return feature;
}

export const TekPointFeatureFactory = {
    makeFeature,
    styleFunction,
    styleCache,
    FEATURE_TYPE,
};
